<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="18" viewBox="0 0 24 18">
    <path class="a" d="M7,7a3,3,0,1,0,3,3A3,3,0,0,0,7,7ZM6,10a1,1,0,1,1,1,1A1,1,0,0,1,6,10Z"
          transform="translate(0 -3)"/>
    <path class="a"
          d="M3,3A3,3,0,0,0,0,6V18a3,3,0,0,0,3,3H21a3,3,0,0,0,3-3V6a3,3,0,0,0-3-3ZM21,5H3A1,1,0,0,0,2,6V18a1,1,0,0,0,1,1H7.314l6.879-6.879a3,3,0,0,1,4.243,0L22,15.686V6A1,1,0,0,0,21,5Zm0,14H10.142l5.464-5.464a1,1,0,0,1,1.414,0l4.886,4.886A1,1,0,0,1,21,19Z"
          transform="translate(0 -3)"/>
  </svg>
</template>

<script>
export default {
  name: "PictureIcon"
}
</script>

<style scoped>
.a {
  fill: #8ea2a8;
  fill-rule: evenodd;
}
</style>
